/**
 * @file Divider atom — separator rule.
 * @description structured atom: compound parts re-exported from the vendored
 * Gluestack family; this is the only sanctioned import path for app code
 * (RFC §3).
 * @module components/atoms/Divider
 */
export { Divider } from "@/components/ui/divider";
